import { useTranslation } from "react-i18next";

import { getCloudRevenueSubject } from "astrid-firestore/src/api/costs/utils/cloudRevenueCosts";
import { languageName } from "astrid-helpers/src/languages";
import money from "astrid-helpers/src/money";

import usePriceTypes from "../../../../prices/hooks/usePriceTypes";

export default function useCloudRevenuesColumns() {
	const { t } = useTranslation();

	const priceTypeNames = usePriceTypes();

	return [
		{
			id: "created",
			Header: t("created", "Created"),
			accessor: ({ created }) => created?.toDate().getTime() || "",
			Cell: ({ value }) => new Date(value).toLocaleString(),
			collapsing: true,
		},
		{
			id: "firstParty.name",
			filter: "select",
			Header: t("producer", "Producer"),
		},
		{
			id: "secondParty.name",
			filter: "select",
			Header: t("publisher", "Publisher"),
		},
		{
			id: "price.type",
			filter: "select",
			Header: t("type", "Type"),
			accessor: ({ price }) => priceTypeNames[price?.type] || "",
		},
		{
			id: "subject",
			filter: "text",
			Header: t("articleOrPeriod", "Article / period"),
			accessor: (cost) => getCloudRevenueSubject(cost),
		},
		{
			// Only start fees have one.
			id: "meta.language",
			filter: "select",
			Header: t("language", "Language"),
			accessor: ({ meta }) => (meta?.language ? languageName(meta.language, false) : ""),
			collapsing: true,
		},
		{
			id: "meta.works",
			Header: t("works", "Works"),
			accessor: ({ meta }) => meta?.works ?? "",
			collapsing: true,
		},
		{
			id: "total",
			Header: t("sum", "Sum"),
			textAlign: "right",
			collapsing: true,
			Cell: ({ value, row }) => money(value, row.original.price?.currency),
		},
	];
}
